/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GeoJsonGeometryType {
    LINE_STRING = 'LineString',
    POINT = 'Point',
}
